// extracted by mini-css-extract-plugin
module.exports = {"cardWrapper":"style_cardWrapper__AcMMS","paddingBottom":"style_paddingBottom__UO0g7","boxActions":"style_boxActions__YaRLS","buttonWrapper":"style_buttonWrapper__OWvbj"};